import { BaseAction } from './BaseAction';

export enum NotificationActions {
  SendInvitePushNotification = '[Notification] Send Invite Push Notification Request',
  SendInvitePushNotificationSuccess = '[Notification] Send Invite Push Notification Success',
  SendInvitePushNotificationError = '[Notification] Send Invite Push Notification Error',
}

export class SendInvitePushNotification implements BaseAction<NotificationActions> {
  readonly type = NotificationActions.SendInvitePushNotification;

  constructor(public readonly inviteCode: string, public readonly content: string) {}
}

export class SendInvitePushNotificationSuccess implements BaseAction<NotificationActions> {
  readonly type = NotificationActions.SendInvitePushNotificationSuccess;
}

export class SendInvitePushNotificationError implements BaseAction<NotificationActions> {
  readonly type = NotificationActions.SendInvitePushNotificationError;
}

export type NotificationAction = SendInvitePushNotification | SendInvitePushNotificationSuccess | SendInvitePushNotificationError;